"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
var styleOverrides = {
    root: function(param) {
        var theme = param.theme;
        var _obj;
        return _obj = {
            textTransform: 'none',
            minWidth: 'unset',
            minHeight: 'unset',
            fontSize: theme.typography.body1.fontSize,
            padding: '10px 4px',
            marginRight: theme.spacing(4)
        }, _define_property(_obj, _breakpoints.default.up('md'), {
            minWidth: 'unset',
            marginRight: theme.spacing(12),
            fontSize: '2rem',
            padding: '12px 4px'
        }), _define_property(_obj, _breakpoints.default.up('lg'), {
            fontSize: '2rem'
        }), _define_property(_obj, '&:last-child', {
            marginRight: 0
        }), _obj;
    },
    textColorPrimary: function(param) {
        var theme = param.theme;
        return _define_property({
            color: theme.palette.grey.A700
        }, "&.".concat(_material.tabClasses.selected), {
            color: theme.palette.text.primary
        });
    }
};
var defaultProps = {
    disableRipple: true
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiTab.js.map
